module.exports = __webpack_public_path__ + "static/media/logo.ea4138fb.svg";